import { IoIosArrowBack } from "react-icons/io";
import { Header, BackButton, Title } from "../BankSelection";
import InputContainer from "../../../components/Accounts/InputContainer";
import { Terms } from "../BankAccountConnection";
import Button from "../../../components/Button/Button";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";

interface LoginProps {
  handleNext: () => void;
  fipayLogo: string;
  onClickCloseIcon: () => void;
  handleBackButtonClick: () => void;
}
const Login: React.FC<LoginProps> = ({
  handleNext,
  fipayLogo,
  onClickCloseIcon,
  handleBackButtonClick,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <TopWrapper>
        <Header>
          <BackButton onClick={handleBackButtonClick}>
            <IoIosArrowBack size={20} />
          </BackButton>
          <img src={fipayLogo} alt="client logo" />
          <div>
            <img
              src="/assets/svg/x-alt.svg"
              alt="close-icon"
              onClick={onClickCloseIcon}
            />
          </div>
        </Header>

        <Title>Login</Title>

        <InputContainer
          label={"Email"}
          type={"text"}
          placeholder={"Enter your email"}
          onChange={() => {}}
        />
        <InputContainer
          label={"Phone Number"}
          type={"text"}
          placeholder={"Phone Number"}
          onChange={() => {}}
        />
      </TopWrapper>
      <div>
        <Terms>
          By continuing, you agree to Fipay's <br />
          <a href="#"> Terms and Privacy Policy</a>
        </Terms>
        <Button
          title="Sign in"
          id={""}
          green
          padding={"10px 30px"}
          width={"100%"}
          onClick={handleNext}
        />
      </div>
    </>
  );
};

export default Login;
export const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
